<template>
    <div>
        <div class="pageheader pd-t-25 pd-b-15">
            <div class="pd-t-5 pd-b-5">
                <h1 class="pd-0 mg-0 tx-20 text-overflow">Transaksi Keluar</h1>
            </div>
            <div class="breadcrumb pd-0 mg-0">
                <a class="breadcrumb-item" href="#"><i class="fa fa-check-square-o mg-r-5"></i>Transaksi Keluar</a>
                <a class="breadcrumb-item" >
                    <router-link :to="{ name:'transaksi.rusak'}">
                    Rusak
                    </router-link>
                </a>
                <span class="breadcrumb-item active"> Form Rusak</span>
            </div>
        </div> 

        <!-- MAIN CONTENT ================================================== -->
        <div class="row justify-content-center">
            <div class="col-sm-6">
                <div class="card">
                    <div class="modal-card">
                        <form @submit.prevent="submitForm" enctype="multipart/form-data">
                        <div class="card-header">
                            <!-- Title -->
                            <h5 class="card-header-title">
                                Form Transaksi Keluar 
                            </h5>
                            <button v-if="userdata.role != 'auditor'" type="submit" class="col-3 btn btn-primary" @click="submitAktif(true)"><i class="fa fa-save mg-r-5"></i>Simpan</button>
                            <button type="button" v-if="showHideBtn" @click.prevent="showHide(false)" class="ml-2 col-1 btn btn-outline-secondary"><i class="fa fa-angle-double-up"></i></button>
                            <button type="button" v-if="!showHideBtn" @click.prevent="showHide(true)" class="ml-2 col-1 btn btn-secondary"><i class="fa fa-angle-double-down"></i></button>
            
                        </div>
                        
                        <div v-if="showHideBtn" style="margin-bottom:-30px" class="card-body">
                            <input type="hidden" v-model="form.id">
                            <div v-if="userdata.role == 'administrator'" class="form-group row align-items-center">
                                <label class="col-sm-12">Pilih SKPD<span class="text-danger">*</span></label>
                                <div class="col-sm-12">
                                    <v-select 
                                            :options="listPengguna"
                                            :reduce="(label) => label.code"
                                            label="label"
                                            v-model="form.id_user"
                                            @input="handleUser"
                                            ></v-select>
                                </div>
                            </div>
                            <div v-if="userdata.email > 2024" class="form-group row align-items-center">
                                <div class="col-sm-12">
                                    <select id="cardAnggaran" :disabled="isDisabled" @change="getPersediaan()" v-model="form.anggaran" class="form-control">
                                        <option value="APBD">APBD</option>
                                        <option value="BTT">BTT</option>
                                        <option value="BLUD">BLUD</option>
                                        <option value="APBN">APBN</option>
                                        <option value="APBD Provinsi">APBD Provinsi</option>
                                        <option value="CSR">CSR</option>
                                    </select>
                                </div>
                            </div>
                            <hr>
                            <div class="form-group row align-items-center">
                                <label class="col-sm-7">No Bukti/BAST<span class="text-danger">*</span></label>
                                <label class="col-sm-5">Upload Lampiran</label>
                                <div class="col-sm-7">
                                    <input disabled type="text" v-model="select.nomor_surat" value="" class="form-control" placeholder="">
                                    <small>&nbsp;</small>
                                </div>
                                <div class="col-sm-5">
                                    <input ref="fileInput" @change="uploadFile" type="file" accept="application/pdf, image/x-png,image/gif,image/jpeg" value="" class="form-control" placeholder="">
                                    <small class="text-primary">
                                        <a v-if="form.lampiran" :href="$apiconfig + 'uploads/' + form.lampiran" target="_blank" style="cursor:pointer" class="text-primary">Lihat File Sebelumnya<i class="fa fa-external-link ml-2"></i></a>
                                    &nbsp;
                                    </small>
                                </div>
                            </div>
                            <div class="form-group row align-items-center">
                                <label class="col-sm-6">Tanggal Dokumen<span class="text-danger">*</span></label>
                                <label class="col-sm-6">Tanggal Buku<span class="text-danger">*</span></label>
                                <div class="col-sm-6">
                                    <datepicker  :input-class="'form-control'" required=""
                                                v-model="form.tgl_dokumen" placeholder="dd mm YYYY" :disabledDates="disabledStart"></datepicker>
                                </div>
                                <div class="col-sm-6">
                                    <datepicker  :input-class="'form-control'" required="" :disabledDates="disabledDates"
                                                v-model="form.tgl_buku" placeholder="dd mm YYYY"></datepicker>
                                </div>
                                <div v-if="form.id" class="col-sm-6">
                                    <input disabled v-model="selectedDate.tgl_dokumen"  class="form-control" value="12">
                                </div>
                                <div v-if="form.id" class="col-sm-6">
                                    <input disabled v-model="selectedDate.tgl_dokumen" class="form-control" value="12">
                                </div>
                            </div>
                        </div>
                        <div v-if="!showHideBtn" style="margin-bottom:-50px;margin-top:-10px" class="card-body">
                            <div class="webnots-information webnots-notification-box">Klik <i class="fa fa-angle-double-down"></i> untuk melihat informasi Kwitansi</div>
                        </div>
                        <hr>
                        <div v-if="!showForm" style="margin:5px;background-color:#f2f2f2;border-radius:5px"  class="bg-neutral card-body">   
                            <div class="form-group row align-items-center">
                                <div class="col-sm-12">
                                    <button type="submit" class="col-12 btn btn-primary" v-if="form.id" @click="showHide(false)"><i class="fa fa-plus">&nbsp;&nbsp;Tambah Item</i></button>
                                    <button type="submit" class="col-12 btn btn-primary" v-if="!form.id" @click="showHide(false)"><i class="fa fa-plus">&nbsp;&nbsp;Simpan & Tambah Item</i></button>
                                </div>
                            </div>
                        </div>
                        </form>
                        <form @submit.prevent="submitDetailForm" enctype="multipart/form-data">
                        <div v-if="showForm" style="margin:5px;background-color:#f2f2f2;border-radius:5px"  class="bg-neutral card-body">   
                            <input type="hidden" v-model="formDetail.id_usulan">
                            <input type="hidden" v-model="formDetail.id_transaksi">
                            <input type="hidden" v-model="formDetail.id">
                            <input type="hidden" v-model="formDetail.terpakai">
                            <input type="hidden" v-model="formDetail.sisa">
                            <input type="hidden" v-model="formDetail.list">
                            <input type="hidden" v-model="formDetail.tempPrice">
                            <input type="hidden" v-model="formDetail.tempCount">
                            <div class="form-group row align-items-center">
                                <label for="name" class="col-sm-12 col-form-label">Kode Persediaan<span class="text-danger">*</span></label>
                                <div class="col-sm-12">
                                        <v-select 
                                            :options="names"
                                            :reduce="(label) => label.code"
                                            label="label"
                                            v-model="formDetail.id_masuk"
                                            @input="handleSelectionChange"
                                            ></v-select>
                                </div>
                                <label class="mt-2 col-sm-7">Nomor Register</label>
                                <label class="col-sm-5">Upload Lampiran</label>
                                <div class="col-sm-7">
                                    <input type="text" v-model="formDetail.no_regis" value="" class="form-control" placeholder="">
                                    <small class="text-primary">&nbsp;</small>
                                </div>
                                <div class="col-sm-5">
                                    <input ref="fileInput1" @change="uploadBukti" type="file" accept="application/pdf, image/x-png,image/gif,image/jpeg" value="" class="form-control" placeholder="">
                                    <small class="text-primary">
                                        <a v-if="form.bukti" :href="$apiconfig + 'bukti/' + form.bukti" target="_blank" style="cursor:pointer" class="text-primary">Lihat File Sebelumnya<i class="fa fa-external-link ml-2"></i></a>
                                    &nbsp;
                                    </small>
                                </div>
                                <label class="col-sm-12">Alasan</label>
                                <div class="col-sm-12">
                                    <textarea type="text" v-model="formDetail.alasan" value="" class="form-control" placeholder=""></textarea>
                                </div>
                            </div>
                            <div class="form-group row align-items-center">
                                <label class="col-sm-4">Jumlah Dikeluarkan<span class="text-danger">*</span></label>
                                <label class="col-sm-4">Saldo Barang</label>
                                <label class="col-sm-4">Harga Total</label>
                                <div class="col-sm-4">
                                    <input required="" type="text" v-mask="currencyMaskNumber" v-model="formDetail.jumlah" @keyup="Newcalculation()" value="" class="form-control" placeholder="">
                                </div>
                                <div class="col-sm-4">
                                    <input disabled required="" type="text" v-mask="currencyMask" v-model="formDetail.saldo" value="" class="form-control" placeholder="">
                                </div>
                                <div class="col-sm-4">
                                    <input disabled type="text" v-mask="currencyMask" v-model="formDetail.total" value="" class="form-control" placeholder="">
                                </div>
                            </div>
                            <small class="text-danger">*Pembulatan 2 Angka belakang koma</small>
                            <div style="border:2px #ffc83d solid;" class="p-2">
                                <div v-for="(item, index) in dataMasuk" :key="index" class="form-group row align-items-center">
                                    <label class="col-sm-4">Harga</label>
                                    <label class="col-sm-4">Jumlah</label>
                                    <label class="col-sm-4 text-danger">Sisa</label>
                                    <div class="col-sm-4">
                                        <input disabled required="" type="text" v-mask="currencyMask" v-model="item.harga" value="" class="border-warning form-control form-control-sm" placeholder="">
                                    </div>
                                    <div class="col-sm-4">
                                        <input disabled required="" type="text" v-mask="currencyMask" v-model="item.jumlah" value="" class="border-warning form-control form-control-sm" placeholder="">
                                    </div>
                                    <div class="col-sm-4">
                                        <input disabled type="text" v-mask="currencyMask" v-model="item.sisa" value="" class="border-danger form-control form-control-sm" placeholder="">
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row align-items-center">
                                <label for="spesification" class="col-sm-12 col-form-label">Keterangan</label>
                                <div class="col-sm-10">
                                    <textarea style="height:50px" class="form-control" v-model="formDetail.keterangan" name="spesification" id="spesification" ></textarea>
                                </div>
                                <div class="col-sm-2">
                                    <button v-if="formDetail.id_transaksi" type="submit" style="height:50px" class="col-12 btn btn-warning"><i class="fa fa-edit"></i></button>
                                    <button v-if="!formDetail.id_transaksi" type="submit" style="height:50px" class="col-12 btn btn-success"><i class="fa fa-plus"></i></button>
                                </div>
                            </div>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                
                <!-- CONTENT -->
                <div class="tab-content mb-3">
                    <div class="tab-pane show active" id="anggota-tab" role="tabpanel">
                        <div class="card">
                            <div class="card-header">
                                <div class="input-group input-group-flush input-group-merge">
                                    <input type="search" class="form-control form-control-prepended search" v-model="keywords" v-on:keyup.enter="getData()" placeholder="Cari Item...">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <span class="fe fe-search"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table class="m-2 table table-sm table-striped  table-responsive-sm">
                                    <thead>
                                        <tr>
                                            <th style="width:4%">No</th>
                                            <th>Kode Barang</th>
                                            <th>Nama Barang</th>
                                            <th>Jumlah</th>
                                            <th>Total</th>
                                            <th style="width:10%">Aksi</th>
                                        </tr>
                                    </thead>
                                    <tbody >
                                        <tr v-for="(item, index) in dataItem" :key="index">
                                            <td>{{ (index + 1) + (pagination.currentPage - 1) * pagination.limit }}</td>
                                            <td>{{ item.code }}
                                                <a v-if="item.file" :href="$apiconfig + 'bukti/' + item.file" target="_blank" style="cursor:pointer" class="text-primary"><i class="fa fa-external-link ml-2"></i></a>
                                            </td>
                                            <td>{{ item.name }}</td>
                                            <td>{{ item.jumlah }}</td>
                                            <td>{{ item.total | VMask(currencyMask) }}</td>
                                            <td class="text-center">
                                                <button v-if="userdata.id > 2914" @click.prevent="postDelete(item.id)" class="btn btn-danger btn-sm mr-2"><i class="fe fe-trash-2"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="card-footer border-top-0">
                                <div style="float:right">
                                    <!-- <ul class="pagination mb-0"></ul> -->
                                    <v-pagination v-if="pagination.totalPages > 0" v-model="pagination.currentPage"
                                                :page-count="pagination.totalPages"
                                                :classes="pagination.bootstrapPaginationClasses"
                                                :labels="pagination.paginationAnchorTexts"
                                                v-on:change="getData()"></v-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ADD SPACE -->
            </div>
        </div>
        <br>
        <!-- END MAIN CONTENT -->
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import vPagination from 'vue-plain-pagination'
    import vSelect from "vue-select";
    import "vue-select/dist/vue-select.css";

    import Datepicker from 'vuejs-datepicker';
    import moment from 'moment';

    import Vue from 'vue'
    import VueMask from 'v-mask'
    Vue.use(VueMask);
    Vue.component('v-select', vSelect.vSelect);

    import createNumberMask from 'text-mask-addons/dist/createNumberMask';
    const currencyMask = createNumberMask({
        prefix: '',
        allowDecimal: true,
        decimalLimit: 7,
        includeThousandsSeparator: true,
        allowNegative: false,
    });

    const currencyMaskNumber = createNumberMask({
        prefix: '',
        allowDecimal: false,
        decimalLimit: 7,
        includeThousandsSeparator: true,
        allowNegative: false,
    });

    moment.locale('id');

    export default {
        metaInfo: {
            title: 'SI',
            titleTemplate: '%s - Data Persediaan'
        },
        data() {
            return {
                baseUrl: this.$apiconfig,
                selectedItem: null,
                isDisabled: false,
                items: ['Option 1', 'Option 2', 'Option 3'],
                currencyMask,
                currencyMaskNumber,
                dataItem: [],
                listBidang: [],
                names: [],
                satuans: [],
                listPengguna: [],
                dataMasuk: [],
                fetching: true,
                saldoAwal: 0,
                totalAwal: 0,
                satuanDefault: 'Satuan',
                showForm: false,
                showHideBtn: true,
                btnSubmit: true,
                detail : {},
                form: {
                    id: this.$route.params.id ? this.$route.params.id : '',
                    id_user: '',
                    nama_penerima: '',
                    nip_penerima: '',
                    gol_penerima: '',
                    lampiran: '',
                    no_bukti: '',
                    surat_masuk: '',
                    no_dokumen: '',
                    tgl_dokumen: '',
                    tgl_buku: '',
                    status: 'rusak',
                    bidang: '',
                    anggaran: 'APBD',
                },
                selectedDate: {
                    tgl_dokumen: '',
                    tgl_buku: '',
                },
                select: {
                    nama_penerima: '',
                    nip_penerima: '',
                    gol_penerima: '',
                    nomor_surat: '',
                },
                formDetail: {
                    id: this.$route.params.id ? this.$route.params.id : '',
                    id_transaksi: '',
                    id_usulan: '',
                    id_masuk: '',
                    jumlah: '',
                    total: 0,
                    satuan: '',
                    saldo: '',
                    keterangan: '',
                    terpakai: '',
                    sisa: '',
                    list: '',
                    alasan: '',
                    bukti: '',
                    no_regis: ''
                },
                pagination: {         
                    currentPage: 1,
                    totalPages: 0,
                    limit: 10,
                    bootstrapPaginationClasses: {
                        ul: 'pagination',
                        li: 'page-item',
                        liActive: 'active',
                        liDisable: 'disabled',
                        button: 'page-link'  
                    },
                    paginationAnchorTexts: {
                        first: '<i class="fe fe-chevrons-left"></i>',
                        prev: '<i class="fe fe-chevron-left"></i>',
                        next: '<i class="fe fe-chevron-right"></i>',
                        last: '<i class="fe fe-chevrons-right"></i>'
                    }
                },
                keywords: '',
                showSelectYear: true,
            }
        },
        computed: {
            ...mapState(['userdata']),
            disabledStart() {
                const year = parseInt(this.userdata.email);

                const startYear = new Date(year, 0, 1); // 1 Jan YEAR
                const endYear   = new Date(year, 11, 31, 23, 59, 59); // 31 Des YEAR

                return {
                    to: new Date(startYear.getTime() - 1),   // sebelum 1 Jan
                    from: new Date(endYear.getTime() + 1),   // setelah 31 Des
                };
            },

            // Datepicker TANGGAL BUKU
            disabledDates() {
                const year = parseInt(this.userdata.email);

                const startYear = new Date(year, 0, 1);
                const endYear   = new Date(year, 11, 31, 23, 59, 59);

                // jika tgl_dokumen belum dipilih
                if (!this.form.tgl_dokumen) {
                    return {
                        to: new Date(startYear.getTime() - 1),
                        from: new Date(endYear.getTime() + 1),
                    };
                }

                const tglDokumen = new Date(this.form.tgl_dokumen);

                return {
                    // tidak boleh kurang dari tgl_dokumen & tidak boleh < 1 Jan
                    to: new Date(
                        Math.max(startYear.getTime(), tglDokumen.getTime()) - 1
                    ),
                    // tidak boleh lewat 31 Des
                    from: new Date(endYear.getTime() + 1),
                };
            }
        },
        created() {
            this.$store.dispatch('loadUserData');
            this.loadData();
            this.getData();
            this.getSatuan();
            this.getUser();
            this.handleSelectionBidang();
        },
        components: {
            vPagination,
            Datepicker,
            'v-select' : vSelect,
        },
        methods: {
             loadData() {
                this.fetching = true;
                this.$http.get(this.baseUrl + 'transaksi/keluar/form', {
                    params: {
                        page : this.pagination.currentPage,
                        keywords: this.keywords,
                        idTransaksi: this.form.id,
                    }
                })
                    .then((response) => {
                        if(response.data.data.length > 0){
                            this.form.id = response.data.data[0].id;
                            this.form.id_user = response.data.data[0].id_user;
                            this.form.nama_penerima = response.data.data[0].nama_penerima;
                            this.form.nip_penerima = response.data.data[0].nip_penerima;
                            this.form.gol_penerima = response.data.data[0].gol_penerima;
                            this.select.nama_penerima = response.data.data[0].nama_penerima;
                            this.select.nip_penerima = response.data.data[0].nip_penerima;
                            this.select.gol_penerima = response.data.data[0].gol_penerima;
                            this.select.nomor_surat = response.data.data[0].no_bukti;
                            this.form.no_bukti = response.data.data[0].no_bukti;
                            this.form.surat_masuk = response.data.data[0].surat_masuk;
                            this.form.tgl_dokumen = new Date(response.data.data[0].tgl_dokumen);
                            this.form.tgl_buku = new Date(response.data.data[0].tgl_buku);
                            this.form.lampiran = response.data.data[0].file;
                            this.form.bidang = response.data.data[0].bidang;
                            this.form.anggaran = response.data.data[0].anggaran;
                            this.selectedDate.tgl_dokumen = response.data.data[0].tgl_dokumen;
                            this.selectedDate.tgl_buku = response.data.data[0].tgl_buku;
                            if(this.userdata.role == 'administrator'){
                            this.getPersediaan();
                            }
                        }
                        if(this.userdata.role == 'dinas'){
                            this.getPersediaan();
                        }
                        this.getBidang();
                    })
                    .catch((error) => {
                        console.log(error.response.data);
                        this.fetching = false;
                    });
            },
            getData() {
                this.fetching = true;
                this.$http.get(this.baseUrl + 'transaksi/keluar/item', {
                    params: {
                        page : this.pagination.currentPage,
                        keywords: this.keywords,
                        idTransaksi: this.form.id,
                    }
                })
                    .then((response) => {
                        this.dataItem = response.data.data;
                        this.fetching = false;
                        this.pagination.totalPages = response.data.total_page;
                    })
                    .catch((error) => {
                        console.log(error.response.data);
                        this.fetching = false;
                    });
            },
            submitForm() {
                if(this.form.no_bukti != '' && this.form.tgl_buku != '' && this.form.tgl_dokumen != ''){

                const formData = new FormData();
                formData.append('file', this.form.lampiran);
                formData.append('id', this.form.id);
                formData.append('id_user', this.form.id_user);
                formData.append('bidang', this.form.bidang);
                formData.append('no_bukti', this.form.no_bukti);
                formData.append('surat_masuk', this.form.surat_masuk);
                formData.append('tgl_buku', this.convertDate(this.form.tgl_buku));
                formData.append('tgl_dokumen', this.convertDate(this.form.tgl_dokumen));
                formData.append('status', this.form.status);
                formData.append('nama_penerima', this.form.nama_penerima);
                formData.append('nip_penerima', this.form.nip_penerima);
                formData.append('gol_penerima', this.form.gol_penerima);
                formData.append('anggaran', this.form.anggaran);

                this.$http.post(this.baseUrl + 'transaksi/keluar/save', formData)
                .then((response) => {
                    if(this.btnSubmit){
                        this.$swal({
                            icon: 'success',
                            title: "success",
                            text: 'Data berhasil disimpan!',
                            showConfirmButton: false,
                            timer: 1500
                        })
                        this.$router.push('/transaksi/rusak');
                    }
                    this.showForm = true;
                    this.form.id = response.data.data.id
                    this.formDetail.id = response.data.data.id
                    this.getData();

                    this.isDisabled = true;
                    this.selectedDate.tgl_dokumen = this.convertDate(this.form.tgl_dokumen);
                    this.selectedDate.tgl_buku = this.convertDate(this.form.tgl_buku);
                })
                .catch(error => {
                    console.log(error.response.data)
                });

                }else{
                    this.showHideBtn = true;
                     this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Form dengan tanda * wajib diisi!',
                    })
                }
            },
            submitDetailForm() {
                const formData = new FormData();
                formData.append('file', this.formDetail.bukti);
                formData.append('id', this.formDetail.id);
                formData.append('id_transaksi', this.formDetail.id_transaksi);
                formData.append('id_usulan', this.formDetail.id_usulan);
                formData.append('id_masuk', this.formDetail.id_masuk);
                formData.append('jumlah', this.formDetail.jumlah);
                formData.append('total', this.formDetail.total);
                formData.append('satuan', this.formDetail.satuan);
                formData.append('saldo', this.formDetail.saldo);
                formData.append('keterangan', this.formDetail.keterangan);
                formData.append('terpakai', this.formDetail.terpakai);
                formData.append('sisa', this.formDetail.sisa);
                formData.append('list', this.formDetail.list);
                formData.append('alasan', this.formDetail.alasan);
                formData.append('no_regis', this.formDetail.no_regis);
                formData.append('tempCount', this.formDetail.tempCount);
                formData.append('tempPrice', this.formDetail.tempPrice);

                // this.$http.post(this.baseUrl + 'transaksi/keluar/save_detail', this.formDetail)
                this.$http.post(this.baseUrl + 'transaksi/keluar/save_detail', formData)
                .then(response => {
                    this.form.id = response.data.data.id
                    this.formDetail.id = response.data.data.id
                    this.formDetail.id_transaksi = '';
                    this.formDetail.id_usulan = '';
                    this.formDetail.id_masuk = '';
                    this.formDetail.jumlah = '';
                    this.formDetail.total = '';
                    this.formDetail.satuan = '';
                    this.formDetail.saldo = '';
                    this.formDetail.keterangan = '';
                    this.formDetail.terpakai = '';
                    this.formDetail.sisa = '';
                    this.formDetail.alasan = '';
                    this.formDetail.bukti = '';
                    this.formDetail.no_regis = '';
                    this.dataMasuk = [];
                    this.getData();
                })
                .catch(error => {
                    console.log(error.response.data)
                });
            },
            postDelete(id) {
                var fd = new FormData()
                fd.append('id', id)
                fd.append('user', this.form.id_user)
                this.$swal({
                    title: 'Apakah kamu yakin?',
                    html: 'Item yang dihapus tidak dapat di kembalikan',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        this.$http({
                            url: this.baseUrl + 'transaksi/keluar/delete',
                            method: 'post',
                            data: fd
                        }).then((response) => {
                            if(response.data.status){
                                this.$swal({
                                    icon: 'success',
                                    title: 'Success',
                                    text: response.data.message,
                                })
                            }else{
                                this.$swal({
                                    icon: 'error',
                                    title: 'Oops...',
                                    text: response.data.message,
                                })
                            }
                            this.formDetail.id_usulan = '';
                            this.formDetail.id_masuk = '';
                            this.formDetail.jumlah = '';
                            this.formDetail.total = '';
                            this.formDetail.satuan = '';
                            this.formDetail.saldo = '';
                            this.formDetail.keterangan = '';
                            this.formDetail.terpakai = '';
                            this.formDetail.sisa = '';
                            this.formDetail.alasan = '';
                            this.formDetail.bukti = '';
                            this.formDetail.no_regis = '';
                            this.dataMasuk = [];
                            this.getData();
                        }).catch(error => {
                            console.log(error.response.data)
                        })
                    }
                });
            },
            getPersediaan() {
                this.fetching = true;
                this.$http.get(this.baseUrl + 'transaksi/masuk/select', {
                    params: {
                        keywords: this.keywords,
                        user: this.form.id_user,
                        anggaran: this.form.anggaran,
                    }
                })
                    .then((response) => {
                        let data = response.data.data;
                        data.forEach((item) => {
                            this.names.push({
                            label: item.persediaan + ' # ' + item.name + ' | ' + item.satuan,
                            code: item.id,
                            status: item.status,
                            });
                        });
                    })
                    .catch((error) => {
                        console.log(error.response.data);
                    });
            },
            getSatuan() {
                this.fetching = true;
                this.$http.get(this.baseUrl + 'admin/master/satuan/select', {
                    params: {
                        page : this.pagination.currentPage,
                        keywords: this.keywords,
                        status: 1,
                    }
                })
                    .then((response) => {
                        let data = response.data.data;
                        data.forEach((item) => {
                            this.satuans.push({
                            label: item.satuan,
                            code: item.id,
                            status: item.status,
                            });
                        });
                    })
                    .catch((error) => {
                        console.log(error.response.data);
                    });
            },
            getUser() {
                this.fetching = true;
                if(this.userdata.role == 'administrator'){
                    this.$http.get(this.baseUrl + 'admin/master/pengguna/select', {
                    params: {
                            page : this.pagination.currentPage,
                            keywords: this.keywords,
                            role: 'dinas',
                        }
                    })
                        .then((response) => {
                            let data = response.data.data;
                            data.forEach((item) => {
                                this.listPengguna.push({
                                label: item.name,
                                code: item.id,
                                });
                            });
                        })
                        .catch((error) => {
                            console.log(error.response.data);
                        }); 
                }
            },
            getBidang() {
                this.$http.get(this.baseUrl + 'admin/master/bidang/list', {
                params: {
                        keywords: this.keywords,
                        id_user: this.form.id_user,
                    }
                })
                    .then((response) => {
                        let data = response.data.data;
                        data.forEach((item) => {
                            this.listBidang.push({
                            label: item.bidang,
                            code: item.id,
                            });
                        });
                    })
                    .catch((error) => {
                        console.log(error.response.data);
                    }); 
            },
            handleSelectionChange: function() {
                
                this.$http.get(this.baseUrl + 'transaksi/masuk/list', {
                    params: {
                            idMasuk : this.formDetail.id_masuk,
                            user : this.form.id_user,
                            tgl_dokumen : this.form.tgl_dokumen,
                            anggaran : this.form.anggaran,
                            id : this.form.id,
                        }
                    })
                        .then((response) => {
                            if(response.data.status){
                                this.dataMasuk = response.data.data;
                                this.formDetail.saldo = response.data.saldo;
                                this.formDetail.id_usulan = response.data.id_usulan;
                                this.formDetail.satuan = response.data.satuan;
                                this.saldoAwal = response.data.saldo;
                                this.formDetail.total  = 0;
                                this.formDetail.jumlah = '';
                            }else{
                                this.$swal({
                                    icon: 'error',
                                    title: 'Oops...',
                                    text: response.data.message,
                                })
                                this.formDetail.jumlah = '';
                                this.formDetail.total = '';
                                this.formDetail.satuan = '';
                                this.formDetail.saldo = '';
                                this.formDetail.keterangan = '';
                                this.formDetail.terpakai = '';
                                this.formDetail.sisa = '';
                                this.formDetail.id_masuk = '';
                                this.formDetail.alasan = '';
                                this.formDetail.bukti = '';
                                this.formDetail.no_regis = '';
                                this.dataMasuk = [];
                            }
                        })
                        .catch((error) => {
                            console.log(error.response.data);
                        }); 
            },
            handleUser: function() {
                this.getPersediaan();
                this.getBidang();
            },
            Newcalculation: function() {
                this.$http.get(this.baseUrl + 'transaksi/masuk/calculation', {
                params: {
                        stock: this.formDetail.saldo,
                        id_usulan: this.formDetail.id_usulan,
                        id_satuan: this.formDetail.satuan,
                        user: this.form.id_user,
                        jumlah: this.formDetail.jumlah,
                        anggaran: this.form.anggaran,
                        tgl_dokumen: this.form.tgl_dokumen,
                    }
                })
                    .then((response) => {
                        this.UseStock = response.data.data;
                        const conv_jumlah = this.formDetail.jumlah.replace(/\D/g, '');
                        const conv_saldo  = this.formDetail.saldo.replace(/\D/g, '');
                        if(parseInt(conv_jumlah) > parseInt(conv_saldo)){
                            this.formDetail.jumlah = this.formDetail.saldo;
                            this.formDetail.total  = response.data.totalItem;
                            this.formDetail.list   = '';
                            this.formDetail.tempPrice   = '';
                            this.formDetail.tempCount   = '';
                            this.formDetail.terpakai =  '';
                            this.formDetail.sisa   =  '';
                        }else{
                            this.formDetail.total  = response.data.totalItem;
                            this.formDetail.list   = response.data.list;
                            this.formDetail.tempPrice   = response.data.tempPrice;
                            this.formDetail.tempCount   = response.data.tempCount;
                            this.formDetail.terpakai = response.data.UsedItem;
                            this.formDetail.sisa   = response.data.sisa;
                        }
                    })
                    .catch((error) => {
                        console.log(error.response.data);
                    });
            },
            calculation(){
                let parseJumlah = parseInt(this.formDetail.jumlah);
                let parseItem   = parseInt(this.dataMasuk[0].temp_sisa);
                let sumSatu;
                let sumDua;
                // let sumTiga;
                if(this.dataMasuk.length == 2){
                    sumSatu  = parseInt(this.dataMasuk[0].temp_sisa) + parseInt(this.dataMasuk[1].temp_sisa);
                    sumDua   = this.formDetail.jumlah;
                    // sumTiga  = this.formDetail.jumlah;
                }else if(this.dataMasuk.length == 3){
                    sumSatu  = parseInt(this.dataMasuk[0].temp_sisa) + parseInt(this.dataMasuk[1].temp_sisa);
                    sumDua   = parseInt(sumSatu) + parseInt(this.dataMasuk[2].temp_sisa);
                    // sumTiga  = this.formDetail.jumlah;
                }else{
                    sumSatu = this.formDetail.jumlah;
                    sumDua  = this.formDetail.jumlah;
                    // sumTiga = this.formDetail.jumlah;
                }

                if(this.formDetail.jumlah > this.saldoAwal){
                    this.formDetail.jumlah = this.saldoAwal;
                    parseJumlah = parseInt(this.saldoAwal);
                }
                this.formDetail.saldo = this.saldoAwal - this.formDetail.jumlah;
                if(this.formDetail.jumlah != ''){
                    if(parseJumlah <= parseItem){ 
                        // JIKA FIFO 1
                        this.formDetail.total  = parseJumlah * parseFloat(this.dataMasuk[0].harga.replaceAll(",", ""));
                        this.dataMasuk[0].sisa = this.dataMasuk[0].temp_sisa - parseJumlah;
                        if(this.dataMasuk.length > 1){
                            this.dataMasuk[1].sisa = this.dataMasuk[1].temp_sisa;
                        }
                        if(this.dataMasuk.length > 2){
                            this.dataMasuk[2].sisa = this.dataMasuk[2].temp_sisa;
                        }
                        this.formDetail.terpakai = 1;
                        this.formDetail.sisa     = this.dataMasuk[0].sisa;
                        this.formDetail.list     = this.dataMasuk[0].id;
                    }else if(parseJumlah > parseItem && parseJumlah <= sumSatu){
                        // JIKA FIFO 2
                        let exSatu    = parseInt(this.dataMasuk[0].temp_sisa) * parseFloat(this.dataMasuk[0].harga.replaceAll(",", ""));
                        let tmpSatu   = parseInt(this.formDetail.jumlah) - parseInt(this.dataMasuk[0].temp_sisa);
                        this.formDetail.total = parseInt(exSatu) + (tmpSatu * parseFloat(this.dataMasuk[1].harga.replaceAll(",", "")));
                        this.dataMasuk[0].sisa = 0;
                        this.dataMasuk[1].sisa = this.dataMasuk[1].temp_sisa - tmpSatu;
                        if(this.dataMasuk.length > 2){
                            this.dataMasuk[2].sisa = this.dataMasuk[2].temp_sisa;
                        }
                        this.formDetail.terpakai = 2;
                        this.formDetail.sisa     = this.dataMasuk[1].sisa;
                        this.formDetail.list     = this.dataMasuk[0].id + ',' + this.dataMasuk[1].id;
                    }else if(parseJumlah > sumSatu && parseJumlah <= sumDua){
                        // JIKA FIFO 3
                        let exSatu    = parseInt(this.dataMasuk[0].temp_sisa) * parseFloat(this.dataMasuk[0].harga.replaceAll(",", ""));
                        let exDua     = parseInt(this.dataMasuk[1].temp_sisa) * parseFloat(this.dataMasuk[1].harga.replaceAll(",", ""));
                        let tmpSatu   = parseInt(this.formDetail.jumlah) - parseInt(sumSatu);
                        this.formDetail.total = parseInt(exSatu) + parseInt(exDua) + (tmpSatu * parseFloat(this.dataMasuk[2].harga.replaceAll(",", "")));
                        this.dataMasuk[0].sisa = 0;
                        this.dataMasuk[1].sisa = 0;
                        this.dataMasuk[2].sisa = this.dataMasuk[2].temp_sisa - tmpSatu;
                        this.formDetail.terpakai = 3;
                        this.formDetail.sisa     = this.dataMasuk[2].sisa;
                        this.formDetail.list     = this.dataMasuk[0].id + ',' + this.dataMasuk[1].id + ',' + this.dataMasuk[2].id;
                    }
                }else{
                    this.dataMasuk[0].sisa = this.dataMasuk[0].temp_sisa;
                    if(this.dataMasuk.length > 1){
                        this.dataMasuk[1].sisa = this.dataMasuk[1].temp_sisa;
                    }
                    if(this.dataMasuk.length > 2){
                        this.dataMasuk[2].sisa = this.dataMasuk[2].temp_sisa;
                    }
                    this.formDetail.total    = 0;
                    this.formDetail.terpakai = '';
                    this.formDetail.sisa     = '';
                    this.formDetail.list     = '';
                }
            },
            convertDate : function (date) {
                return moment(date, 'YYYY-MM-DD').format('yyyy-MM-DD');
            },
            uploadFile() {
                const file = this.$refs.fileInput.files[0]; 
                var fsize  = ((file.size/1024)/1024).toFixed(4); // MB
                
                if(fsize >= 5) {
                    alert("File yang di upload tidak boleh lebih 5 MB");
                } else {
                   this.form.lampiran = this.$refs.fileInput.files[0];
                }
            },
            uploadBukti() {
                const file = this.$refs.fileInput1.files[0]; 
                var fsize  = ((file.size/1024)/1024).toFixed(4); // MB
                
                if(fsize >= 5) {
                    alert("File yang di upload tidak boleh lebih 5 MB");
                } else {
                   this.formDetail.bukti = this.$refs.fileInput1.files[0];
                }
            },
            showHide(key) {
                this.showHideBtn = key;
                this.btnSubmit   = key;
            },
            submitAktif(key){
                this.btnSubmit   = key;
            },
            handleSelectionBidang: function() {
                this.$http.get(this.baseUrl + `transaksi/keluar/nomor?user=${this.form.id_user}`)
                    .then((response) => {
                        if(this.form.no_bukti == ''){
                            this.form.no_bukti = response.data.data[0].nomor_surat;
                            this.select.nomor_surat = response.data.data[0].nomor_surat;
                        }
                    })
                    .catch((error) => {
                        console.log(error.response.data);
                        this.fetching = false;
                    }); 
            },
        },
    };
</script>
<style>
    /* style sweetalert */
    .swal2-html-container {
        display: block;
        text-align: center;
    }
</style>